export default __webpack_public_path__ + "static/media/ferret.20d6877a.png";